<template>
  <v-dialog
    v-model="value"
    v-bind="cfg"
  >
    <v-card>
      <v-card-title class="text-body-1">
        {{ cfg.message }}

        {{ okFns.length }}
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="btnClick(false)"
        >
          {{ $t('Text.False') }}
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="btnClick(true)"
        >
          {{ $t('Text.True') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

const _cfg = {
  message: '',
  maxWidth: '300'
}

export default {
  data: function () {
    return {
      okFns: [],
      cancelFns: [],
      dismissFns: [],
      value: false,
      cfg: { ..._cfg }
    }
  },
  watch: {
    value: function (val) {
      if (!val) {
        this.dismissFns.forEach(fn => { fn() })
        this._clear()
      }
    }
  },
  methods: {
    show: function (props) {
      this.cfg = { ..._cfg, ...props }
      this.value = true
      return this
    },
    hide: function (fn) {
      this.value = false
      return this
    },
    onOk: function (fn) {
      this.okFns.push(fn)
      return this
    },
    onCancel: function (fn) {
      this.cancelFns.push(fn)
      return this
    },
    onDismiss: function (fn) {
      this.dismissFns.push(fn)
      return this
    },
    btnClick: function (status) {
      if (status) {
        this.okFns.forEach(fn => { fn() })
      } else {
        this.cancelFns.forEach(fn => { fn() })
      }
      this.value = false
    },
    _clear: function () {
      setTimeout(() => {
        this.okFns = []
        this.cancelFns = []
        this.dismissFns = []
      }, 100)
    }
  }
}
</script>
